const SCHEDULE_LABELS: readonly [string, string][] = [
  ["Spieltag", "Matchday"],
  ["Achtelfinale", "Round of 16"],
  ["Viertelfinale", "Quarterfinal"],
  ["Halbfinale", "Semifinal"],
  ["Finale", "Final"],
];

const SCHEDULE_LABELS_LONGEST_FIRST = [...SCHEDULE_LABELS].sort(
  (a, b) => b[0].length - a[0].length
);

export function translateScheduleLabel(
  label: string | null | undefined,
  locale: string | undefined
): string {
  if (!label) return label ?? "";
  if (locale !== "en") return label;

  return SCHEDULE_LABELS_LONGEST_FIRST.reduce(
    (text, [from, to]) => text.split(from).join(to),
    label
  );
}
